// ExportarApostasInstagram.js
import React, { useEffect, useMemo, useRef, useState } from "react";
import "./ExportarApostasInstagram.css";
import * as htmlToImage from "html-to-image";
import JSZip from "jszip";

/* ====================== CONSTANTES ====================== */
const ORDEM_MODOS = [
  "oscar-vencedores", "oscar-indicados",
  "globodeouro-vencedores", "globodeouro-indicados",
  "bafta-vencedores", "bafta-indicados",
  "sagawards-vencedores", "sagawards-indicados",
  "criticschoice-vencedores", "criticschoice-indicados",
  "pga-vencedores", "pga-indicados",
  "dga-vencedores", "dga-indicados",
];

const LABEL_MODO = {
  "oscar-vencedores":"VENCEDORES DO OSCAR",
  "oscar-indicados":"INDICADOS AO OSCAR",
  "globodeouro-vencedores":"VENCEDORES DO GLOBO DE OURO",
  "globodeouro-indicados":"INDICADOS AO GLOBO DE OURO",
  "bafta-vencedores":"VENCEDORES DO BAFTA",
  "bafta-indicados":"INDICADOS AO BAFTA",
  "sagawards-vencedores":"VENCEDORES DO SAG AWARDS",
  "sagawards-indicados":"INDICADOS AO SAG AWARDS",
  "criticschoice-vencedores":"VENCEDORES DO CRITICS CHOICE",
  "criticschoice-indicados":"INDICADOS DO CRITICS CHOICE",
  "pga-vencedores":"VENCEDORES DO PGA",
  "pga-indicados":"INDICADOS DO PGA",
  "dga-vencedores":"VENCEDORES DO DGA",
  "dga-indicados":"INDICADOS DO DGA",
};

const CATEGORIAS_ORDEM = {
  "oscar-indicados":[
    "melhorfilme","melhordirecao","melhorator","melhoratriz","melhoratorcoadjuvante","melhoratrizcoadjuvante","melhorescalacaodeelenco","melhorroteirooriginal","melhorroteiroadaptado","melhorfilmeinternacional","melhoranimacao","melhordocumentario","melhoredicao","melhorfotografia","melhorfigurino","melhordirecaodearte","melhormaquiagem","melhorefeitosvisuais","melhortrilhasonora","melhorcancaooriginal","melhorsom","melhorcurtametragem","melhoranimacaoemcurtametragem","melhordocumentarioemcurtametragem","melhorduble"
  ],
  "oscar-vencedores":[
    "melhorfilme","melhordirecao","melhorator","melhoratriz","melhoratorcoadjuvante","melhoratrizcoadjuvante","melhorescalacaodeelenco","melhorroteirooriginal","melhorroteiroadaptado","melhorfilmeinternacional","melhoranimacao","melhordocumentario","melhoredicao","melhorfotografia","melhorfigurino","melhordirecaodearte","melhormaquiagem","melhorefeitosvisuais","melhortrilhasonora","melhorcancaooriginal","melhorsom","melhorcurtametragem","melhoranimacaoemcurtametragem","melhordocumentarioemcurtametragem","melhorduble"
  ],
  "globodeouro-indicados":[
    "melhorfilmeemdrama","melhorfilmeemcomedia","melhorfilmeblockbuster","melhordirecao","melhoratoremdrama","melhoratrizemdrama","melhoratoremcomediaoumusical","melhoratrizemcomediaoumusical","melhoratorcoadjuvante","melhoratrizcoadjuvante","melhorroteiro","melhorcancaooriginal","melhortrilhasonora","melhoranimacao","melhorfilmeemlinguanaoinglesa"
  ],
  "globodeouro-vencedores":[
    "melhorfilmeemdrama","melhorfilmeemcomedia","melhorfilmeblockbuster","melhordirecao","melhoratoremdrama","melhoratrizemdrama","melhoratoremcomediaoumusical","melhoratrizemcomediaoumusical","melhoratorcoadjuvante","melhoratrizcoadjuvante","melhorroteiro","melhorcancaooriginal","melhortrilhasonora","melhoranimacao","melhorfilmeemlinguanaoinglesa"
  ],
  "sagawards-indicados":[
    "melhorelenco","melhorator","melhoratriz","melhoratorcoadjuvante","melhoratricoadjuvante","melhorequipededuble"
  ],
  "sagawards-vencedores":[
    "melhorelenco","melhorator","melhoratriz","melhoratorcoadjuvante","melhoratricoadjuvante","melhorequipededuble"
  ],
  "criticschoice-indicados":[
    "melhorfilme","melhordirecao","melhorator","melhoratriz","melhoratorcoadjuvante","melhoratrizcoadjuvante","melhorjovematoratriz","melhorelenco","melhorroteirooriginal","melhorroteiroadaptado","melhorfotografia","melhoredicao","melhordirecaodearte","melhorfigurino","melhormaquiagem","melhorefeitosvisuais","melhorcomedia","melhorfilmeinternacional","melhoranimacao","melhorcancao","melhortrilhasonora"
  ],
  "criticschoice-vencedores":[
    "melhorfilme","melhordirecao","melhorator","melhoratriz","melhoratorcoadjuvante","melhoratrizcoadjuvante","melhorjovematoratriz","melhorelenco","melhorroteirooriginal","melhorroteiroadaptado","melhorfotografia","melhoredicao","melhordirecaodearte","melhorfigurino","melhormaquiagem","melhorefeitosvisuais","melhorcomedia","melhorfilmeinternacional","melhoranimacao","melhorcancao","melhortrilhasonora"
  ],
  "dga-indicados":[ "melhordirecao" ],
  "dga-vencedores":[ "melhordirecao" ],
  "pga-indicados":[ "melhorfilme","melhoranimacao","melhordocumentario" ],
  "pga-vencedores":[ "melhorfilme","melhoranimacao","melhordocumentario" ],
  "bafta-indicados":[
    "melhorfilme","melhordirecao","melhorfilmeinternacional","melhorfilmebritanico","melhorfilmefamiliar","melhordocumentario","melhoranimacao","melhorator","melhoratriz","melhoraorcoadjuvante","melhoratrizcoadjuvante","melhoratoratrizemascensao","melhorescalacao","melhorestreiadeumdiretorescritorouprodutorbritanico","melhorroteirooriginal","melhorroteiroadaptado","melhorfotografia","melhorfigurino","melhorsom","melhoredicao","melhorefeitosvisuais","melhordirecaodearte","melhormaquiagem","melhortrilhasonora","melhorcurtabritanico","melhorcurtadeanimacaobritanico"
  ],
  "bafta-vencedores":[
    "melhorfilme","melhordirecao","melhorfilmeinternacional","melhorfilmebritanico","melhorfilmefamiliar","melhordocumentario","melhoranimacao","melhorator","melhoratriz","melhoraorcoadjuvante","melhoratrizcoadjuvante","melhoratoratrizemascensao","melhorescalacao","melhorestreiadeumdiretorescritorouprodutorbritanico","melhorroteirooriginal","melhorroteiroadaptado","melhorfotografia","melhorfigurino","melhorsom","melhoredicao","melhorefeitosvisuais","melhordirecaodearte","melhormaquiagem","melhortrilhasonora","melhorcurtabritanico","melhorcurtadeanimacaobritanico"
  ],
};

const LABEL_CAT = {
  melhorfilme:"Melhor Filme",
  melhordirecao:"Melhor Direção",
  melhorator:"Melhor Ator",
  melhoratriz:"Melhor Atriz",
  melhoratorcoadjuvante:"Melhor Ator Coadjuvante",
  melhoratrizcoadjuvante:"Melhor Atriz Coadjuvante",
  melhorescalacaodeelenco:"Melhor Escalação de Elenco",
  melhorroteirooriginal:"Melhor Roteiro Original",
  melhorroteiroadaptado:"Melhor Roteiro Adaptado",
  melhorfilmeinternacional:"Melhor Filme Internacional",
  melhoranimacao:"Melhor Animação",
  melhordocumentario:"Melhor Documentário",
  melhoredicao:"Melhor Edição",
  melhorfotografia:"Melhor Fotografia",
  melhorfigurino:"Melhor Figurino",
  melhordirecaodearte:"Melhor Direção de Arte",
  melhormaquiagem:"Melhor Maquiagem",
  melhorefeitosvisuais:"Melhores Efeitos Visuais",
  melhortrilhasonora:"Melhor Trilha Sonora",
  melhorcancaooriginal:"Melhor Canção Original",
  melhorsom:"Melhor Som",
  melhorcurtametragem:"Melhor Curta-Metragem",
  melhoranimacaoemcurtametragem:"Melhor Animação em Curta-Metragem",
  melhordocumentarioemcurtametragem:"Melhor Documentário em Curta-Metragem",
  melhorduble:"Melhor Coordenação de Dublê",
  melhorfilmeemdrama:"Melhor Filme em Drama",
  melhorfilmeemcomedia:"Melhor Filme em Comédia ou Musical",
  melhorfilmeblockbuster:"Melhor Filme Blockbuster",
  melhoratoremdrama:"Melhor Ator em Drama",
  melhoratrizemdrama:"Melhor Atriz em Drama",
  melhoratoremcomediaoumusical:"Melhor Ator em Comédia ou Musical",
  melhoratrizemcomediaoumusical:"Melhor Atriz em Comédia ou Musical",
  melhorroteiro:"Melhor Roteiro",
  melhorfilmeemlinguanaoinglesa:"Melhor Filme em Língua Não-Inglesa",
  melhorelenco:"Melhor Elenco",
  melhoratricoadjuvante:"Melhor Atriz Coadjuvante",
  melhorequipededuble:"Melhor Equipe de Dublês",
  melhorjovematoratriz:"Melhor Jovem Ator/Atriz",
  melhorcomedia:"Melhor Comédia",
  melhorcancao:"Melhor Canção",
  melhorfilmebritanico:"Melhor Filme Britânico",
  melhorfilmefamiliar:"Melhor Filme Familiar",
  melhoraorcoadjuvante:"Melhor Ator Coadjuvante",
  melhoratoratrizemascensao:"Melhor Ator/Atriz em Ascensão",
  melhorescalacao:"Melhor Escalação",
  melhorestreiadeumdiretorescritorouprodutorbritanico:"Melhor Estreia de um Diretor, Escritor ou Produtor Britânico",
  melhorcurtabritanico:"Melhor Curta Britânico",
  melhorcurtadeanimacaobritanico:"Melhor Curta de Animação Britânico",
};

const LOGO_URL = "https://i.imgur.com/E7lbYks.png";
const ICON_EXPORT = "https://i.imgur.com/USywV51.png";
const PLACEHOLDER = "https://i.imgur.com/zogzulV.png";

/* ====================== HELPERS ====================== */
const capFirst = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
const slug = (s) => (s || "")
  .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  .toLowerCase().replace(/[^a-z0-9]+/g, "-")
  .replace(/(^-|-$)/g, "");

function dataExtenso(valor) {
  if (!valor) return "—";
  const d = valor?.seconds ? new Date(valor.seconds * 1000) : new Date(valor);
  if (isNaN(d)) return "—";
  const dia = d.getDate();
  const mes = capFirst(d.toLocaleDateString("pt-PT", { month: "long" }));
  const ano = d.getFullYear();
  return `${dia} de ${mes} de ${ano}`;
}

function itensDaCategoria(catObj) {
  return Object.entries(catObj || {})
    .filter(([k, v]) => !isNaN(Number(k)) && v?.titulo)
    .map(([, v]) => v)
    .sort((a, b) => (a.ordem || 999) - (b.ordem || 999));
}

function modoTemDados(blocoModo) {
  if (!blocoModo) return false;
  return Object.keys(blocoModo).some((id) => itensDaCategoria(blocoModo[id]).length);
}

function ultimaAtualizacaoModo(blocoModo) {
  let maior = null;
  Object.values(blocoModo || {}).forEach((cat) => {
    const v = cat?.dataAtualizacao;
    if (!v) return;
    const d = v?.seconds ? new Date(v.seconds * 1000) : new Date(v);
    if (!isNaN(d) && (!maior || d > maior)) maior = d;
  });
  return maior;
}

/** Regras de linhas + nBase (largura consistente entre as linhas) */
function splitRowsInfo(qtd, single) {
  if (single) {
    const mapa = {
      5: { rows: [2, 3], nBase: 3 },
      6: { rows: [3, 3], nBase: 3 },
      7: { rows: [4, 3], nBase: 4 },
      8: { rows: [4, 4], nBase: 4 },
      9: { rows: [5, 4], nBase: 5 },
      10:{ rows: [5, 3, 2], nBase: 5 },
    };
    return mapa[qtd] || { rows: [Math.min(qtd, 5)], nBase: Math.min(qtd, 5) };
  }
  if (qtd === 10) return { rows: [5, 5], nBase: 5 };
  if (qtd >= 7 && qtd <= 9) return { rows: [6, qtd - 6], nBase: 6 };
  return { rows: [qtd], nBase: qtd };
}

function classePos(n) {
  if (n === 1) return "pos-1";
  if (n === 2) return "pos-2";
  if (n === 3 || n === 4) return "pos-3-4";
  return "pos-5-plus";
}

/* ====================== COMPONENTE ====================== */
export default function ExportarApostasInstagram({
  modos = [],
  dados = {},
  ranking = {},
  usuario = {},
}) {
  const [aberto, setAberto] = useState(false);

  // ====== dados / filtros
  const modosValidos = useMemo(() => {
    const lista = modos.filter((m) => modoTemDados(dados[m]));
    return [...lista].sort((a, b) => ORDEM_MODOS.indexOf(a) - ORDEM_MODOS.indexOf(b));
  }, [modos, dados]);

  const [modoSel, setModoSel] = useState(modosValidos[0] || "");
  useEffect(() => {
    if (!modosValidos.includes(modoSel)) setModoSel(modosValidos[0] || "");
  }, [modosValidos, modoSel]);

  const categoriasOrdenadas = useMemo(() => {
    const bloco = dados[modoSel] || {};
    let cats = Object.keys(bloco).filter((k) => itensDaCategoria(bloco[k]).length);
    const ordem = CATEGORIAS_ORDEM[modoSel] || [];
    cats.sort(
      (a, b) =>
        (ordem.indexOf(a) === -1 ? 9999 : ordem.indexOf(a)) -
        (ordem.indexOf(b) === -1 ? 9999 : ordem.indexOf(b))
    );
    return cats;
  }, [dados, modoSel]);

  const [selCats, setSelCats] = useState([]);
  useEffect(() => { setSelCats(categoriasOrdenadas); }, [categoriasOrdenadas]); // todas marcadas

  // ====== NOVO: flag "Uma categoria por imagem"
  const [umaPorPagina, setUmaPorPagina] = useState(false);

  // ====== paginação
  function paginar(cats, forceSingle = false) {
    if (forceSingle) {
      // cada categoria vira uma página sozinha
      return cats.map((c) => [c]);
    }

    const bloco = dados[modoSel] || {};
    const out = [];
    let buffer = [];
    const flush = () => { if (buffer.length) { out.push(buffer); buffer = []; } };

    const fila = [...cats];
    while (fila.length) {
      const c = fila.shift();
      const qtd = itensDaCategoria(bloco[c]).length;

      if (qtd === 10 || (qtd >= 7 && qtd <= 9)) {
        flush();
        const extra = fila.find((id) => itensDaCategoria(bloco[id]).length <= 6);
        if (extra) {
          out.push([c, extra]);
          fila.splice(fila.indexOf(extra), 1);
        } else {
          out.push([c]);
        }
        continue;
      }

      buffer.push(c);
      if (buffer.length === 3) flush();
    }
    flush();
    return out;
  }

  const paginas = useMemo(
    () => paginar(selCats, umaPorPagina),
    [selCats, modoSel, dados, umaPorPagina]
  );

  const [pagina, setPagina] = useState(0);
  useEffect(() => setPagina(0), [paginas.length, modoSel, umaPorPagina]);
  useEffect(() => {
    setPagina(p => Math.min(Math.max(0, p), Math.max(0, paginas.length - 1)));
  }, [paginas.length]);

  // ====== pontos e datas
  const pontosModo = ranking?.[modoSel]?.pontosmodo ?? ranking?.[modoSel]?.pontos;
  const blocoModo = dados[modoSel] || {};
  const ultima = ultimaAtualizacaoModo(blocoModo);

  // ====== preview scale (só o canvas)
  const previewAreaRef = useRef(null);
  const [scale, setScale] = useState(0.6);
  useEffect(() => {
    const el = previewAreaRef.current;
    if (!el) return;
    const fit = () => {
      const w = el.clientWidth;
      const h = el.clientHeight;
      const s = Math.min(w / 1080, h / 1350);
      setScale(Math.max(0.18, Math.min(1, s)));
    };
    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(el);
    return () => ro.disconnect();
  }, [aberto]);

  const scrollToPreview = () => {
    previewAreaRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // === DROPDOWN "APOSTAS" (sobreposto, single-select) ===
  const modoWrapRef = useRef(null);
  const [openModo, setOpenModo] = useState(false);
  useEffect(() => {
    function onDocClick(e) {
      if (!openModo) return;
      if (!modoWrapRef.current) return;
      if (!modoWrapRef.current.contains(e.target)) setOpenModo(false);
    }
    function onKey(e) { if (e.key === "Escape") setOpenModo(false); }
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [openModo]);

  // ====== dropdown de categorias (sobreposto)
  const ddWrapRef = useRef(null);
  const [openDD, setOpenDD] = useState(false);
  useEffect(() => {
    function onDocClick(e) {
      if (!openDD) return;
      if (!ddWrapRef.current) return;
      if (!ddWrapRef.current.contains(e.target)) setOpenDD(false);
    }
    function onKey(e) { if (e.key === "Escape") setOpenDD(false); }
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [openDD]);

  const fotoUser = usuario?.fotoPerfil || "https://i.imgur.com/t0gsZRT.png";
  const nomeUser = `${usuario?.nome || "João"} ${usuario?.sobrenome || "Ninguém"}`;

  function toggleCategoria(cid) {
    setSelCats(prev => {
      const set = new Set(prev);
      if (set.has(cid)) set.delete(cid); else set.add(cid);
      return categoriasOrdenadas.filter(x => set.has(x));
    });
  }

  /* ============ DOWNLOAD ============ */
  const canvasRef = useRef(null);
  const [renderHidden, setRenderHidden] = useState(false);

  const baseName = useMemo(
    () => `apostas-${slug(LABEL_MODO[modoSel] || modoSel)}${umaPorPagina ? "-uma-cat" : ""}`,
    [modoSel, umaPorPagina]
  );

  const toPNG = async (node) => {
  return await htmlToImage.toPng(node, {
    pixelRatio: 2,
    cacheBust: true,
    backgroundColor: "#e9ad0c",
    width: 1080,
    height: 1350,
    // ajuda em Safari/iOS e com fontes externas
    skipFonts: true,
  });
};

  const downloadUrl = (url, filename) => {
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    setTimeout(() => a.remove(), 0);
  } catch (e) {
    // Fallback (iOS/Safari costuma ignorar a.download)
    window.open(url, "_blank");
  }
};

const handleDownloadOne = async () => {
  try {
    const node = canvasRef.current;
    if (!node) return;
    const dataUrl = await toPNG(node);
    downloadUrl(
      dataUrl,
      `${baseName}-p${String(pagina + 1).padStart(2, "0")}.png`
    );
  } catch (err) {
    console.error("Falha ao gerar PNG:", err);
    alert("Não consegui gerar a imagem. Veja o console para o erro (CORS?).");
  }
};

const handleDownloadAll = async () => {
  try {
    if (!paginas.length) return;
    setRenderHidden(true);
    await new Promise((r) => setTimeout(r, 40));
    const nodes = Array.from(
      document.querySelectorAll(".ig-hidden-captures .ig-canvas")
    );
    const zip = new JSZip();
    for (let i = 0; i < nodes.length; i++) {
      const dataUrl = await toPNG(nodes[i]);
      const b64 = dataUrl.split(",")[1];
      const name = `${baseName}-p${String(i + 1).padStart(2, "0")}.png`;
      zip.file(name, b64, { base64: true });
    }
    const blob = await zip.generateAsync({ type: "blob" });
    const url = URL.createObjectURL(blob);
    downloadUrl(url, `${baseName}.zip`);
    URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Falha ao gerar ZIP:", err);
    alert("Não consegui gerar o ZIP. Veja o console para o erro (CORS?).");
  } finally {
    setRenderHidden(false);
  }
};

  /* ============ SUBCOMPONENTES ============ */
  function Candidato({ item, idx }) {
    const pos = idx + 1;
    const acertou = item?.acertou === true || item?.acertou === "true" || item?.acertou === 1;
    const errou = item?.acertou === false || item?.acertou === "false" || item?.acertou === 0;
    const filmeOuPais = item?.filme || item?.pais || "";
    const img = item?.imagem || PLACEHOLDER;

    return (
      <div className={`ig-cand ${errou ? "miss" : ""}`}>
        <div className="ig-thumb-frame">
          <div className="ig-thumb-mask">
            <img
              className="ig-thumb"
              src={img}
              alt={item?.titulo || ""}
              loading="lazy"
              crossOrigin="anonymous"
              onError={(e) => {
                if (e.currentTarget.src !== PLACEHOLDER)
                  e.currentTarget.src = PLACEHOLDER;
              }}
            />
          </div>
          {acertou && <span className="ig-hit">ACERTEI</span>}
          <span className={`ig-badge ${classePos(pos)}`}>{pos}º</span>
        </div>

        <div className="ig-meta">
          <strong className="ig-titulo">{item?.titulo || "—"}</strong>
          <div className="ig-sub">{filmeOuPais}</div>
        </div>
      </div>
    );
  }

  function Categoria({ catId, single }) {
    const cat = blocoModo[catId] || {};
    const itens = itensDaCategoria(cat);
    const { rows, nBase } = splitRowsInfo(itens.length, single);
    const pontosCat = ranking?.[modoSel]?.[catId]?.pontos;

    let offset = 0;

    return (
      <section className={`ig-cat ${single ? "solo" : ""}`}>
        <div className="ig-cat-head">
          <h3 className="ig-cat-title">{LABEL_CAT[catId] || catId}</h3>
          {Number.isFinite(pontosCat) && <div className="ig-cat-pontos">{pontosCat} pt</div>}
        </div>

        <div className={`ig-cat-body cols-${nBase}`}>
          {rows.map((n, r) => {
            const rowStart = offset;
            const slice = itens.slice(rowStart, rowStart + n);
            offset += n;
            return (
              <div className="ig-row" key={r}>
                {slice.map((it, i) => (
                  <Candidato key={i} item={it} idx={rowStart + i} />
                ))}
              </div>
            );
          })}
        </div>
      </section>
    );
  }

  function Pagina({ cats = [], innerRef = null }) {
    const list = Array.isArray(cats) ? cats : [];
    const single = list.length === 1;
    return (
      <div className="ig-canvas" ref={innerRef}>
        <header className="ig-top">
          <div className="ig-top-left">
            <div className="ig-titulo-linha1">MINHAS APOSTAS</div>
            <div className="ig-titulo-linha2">{LABEL_MODO[modoSel] || ""}</div>
          </div>

          <div className="ig-top-center">
            {Number.isFinite(pontosModo) && (
              <div className="ig-bolao">
                <div className="ig-bolao-topo">TOTAL</div>
                <div className="ig-bolao-num">{pontosModo}</div>
                <div className="ig-bolao-sub">PONTOS</div>
              </div>
            )}
          </div>

          <div className="ig-top-right">
            <img
              className="ig-logo"
              src={LOGO_URL}
              alt="termometeiro"
              crossOrigin="anonymous"
            />
          </div>
        </header>

        <main className={`ig-content ${single ? "one-cat" : list.length === 2 ? "two-cats" : "three-cats"}`}>
          {list.map((c) => (
            <Categoria key={c} catId={c} single={single} />
          ))}
        </main>

        <footer className="ig-footer">
          <div className="ig-user">
            <img
              className="ig-user-foto"
              src={fotoUser}
              alt={nomeUser}
              crossOrigin="anonymous"
            />
            <div className="ig-user-nome">{nomeUser}</div>
          </div>
          <div className="ig-updated">
            ATUALIZADO EM: <strong>{dataExtenso(ultima)}</strong>
          </div>
        </footer>
      </div>
    );
  }

  if (!modosValidos.length) return null;

  return (
    <>
      {/* Botão flutuante: círculo + pílula */}
      <button className="ig-fab" type="button" onClick={() => setAberto(true)}>
        <span className="ig-fab-circle">
          <img src={ICON_EXPORT} alt="" />
        </span>
        <span className="ig-fab-pill">EXPORTAR APOSTAS EM IMAGEM</span>
      </button>

      {!aberto ? null : (
        <div className="ig-modal-overlay" role="dialog" aria-modal="true">
          <div className="ig-modal">
            <button className="ig-close" onClick={() => setAberto(false)} aria-label="Fechar">
              ×
            </button>

            <div className="ig-side">
              <h2 className="ig-pop-title">EXPORTAR APOSTAS EM IMAGEM</h2>

              {/* APOSTAS (dropdown sobreposto, sem numeração) */}
              <div className="ig-field" ref={modoWrapRef} style={{ position: "relative" }}>
                <span className="ig-field-label">APOSTAS</span>

                <button
                  type="button"
                  className="ig-drop-summary"
                  onClick={() => setOpenModo(v => !v)}
                  aria-expanded={openModo}
                >
                  {LABEL_MODO[modoSel] || "Selecionar"}
                  <span className="ig-caret" style={{ right: 16 }}>▾</span>
                </button>

                {openModo && (
                  <div
                    className="ig-drop-panel"
                    style={{ position: "absolute", top: "calc(100% + 8px)", left: 0, right: 0, zIndex: 20 }}
                  >
                    <ul className="ig-checklist">
                      {modosValidos.map((m) => (
                        <li key={m}>
                          <label
                            className={`ig-option ${modoSel === m ? "is-on" : "is-off"}`}
                            onClick={() => { setModoSel(m); setOpenModo(false); }}
                          >
                            <input type="radio" name="modo-sel" checked={modoSel === m} onChange={() => {}} />
                            <span className="ig-option-text">{LABEL_MODO[m]}</span>
                          </label>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {/* CATEGORIAS (dropdown numerado) */}
              <div className="ig-field" ref={ddWrapRef} style={{ position: "relative" }}>
                <span className="ig-field-label">CATEGORIAS</span>

                <button
                  type="button"
                  className="ig-drop-summary"
                  onClick={() => setOpenDD((v) => !v)}
                  aria-expanded={openDD}
                >
                  ({selCats.length}) Categorias Selecionadas
                  <span className="ig-caret" style={{ right: 16 }}>▾</span>
                </button>

                {openDD && (
                  <div
                    className="ig-drop-panel"
                    style={{ position: "absolute", top: "calc(100% + 8px)", left: 0, right: 0, zIndex: 20 }}
                  >
                    <ul className="ig-checklist">
                      {categoriasOrdenadas.map((cid) => {
                        const order = selCats.indexOf(cid);
                        const isOn = order !== -1;
                        return (
                          <li key={cid}>
                            <label className={`ig-option ${isOn ? "is-on" : "is-off"}`}>
                              <input type="checkbox" checked={isOn} onChange={() => toggleCategoria(cid)} />
                              <span className="ig-check-num">{isOn ? order + 1 : ""}</span>
                              <span className="ig-option-text">{LABEL_CAT[cid] || cid}</span>
                            </label>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
              </div>

              {/* NOVO: Toggle "Uma categoria por imagem" */}
              <div className="ig-field">
                <label className="ig-toggle">
                  <input
                    type="checkbox"
                    checked={umaPorPagina}
                    onChange={(e) => setUmaPorPagina(e.target.checked)}
                    role="switch"
                    aria-checked={umaPorPagina}
                    aria-label="Uma categoria por imagem"
                  />
                  <span className="ig-toggle-text">Uma categoria por imagem</span>
                </label>
              </div>

              {/* Botão Preview (rola até a imagem) */}
              <div className="ig-preview-cta-wrap">
                <button className="ig-btn ghost" type="button" onClick={scrollToPreview}>
                  PREVIEW DA IMAGEM
                </button>
              </div>

              {/* PREVIEW fiel — apenas o canvas escalado */}
              <div ref={previewAreaRef} className="ig-preview-area">
                <div className="ig-preview-center" style={{ display: "grid", placeItems: "center" }}>
                  <div className="ig-preview-scaler" style={{ transform: `scale(${scale})` }}>
                    {paginas.length ? (
                      <Pagina cats={paginas[pagina] || []} innerRef={canvasRef} />
                    ) : (
                      <div className="ig-vazio">Selecione pelo menos uma categoria.</div>
                    )}
                  </div>
                </div>
              </div>

              {/* Renderização oculta para capturar TODAS as páginas (ZIP) */}
              {renderHidden && (
                <div
                  className="ig-hidden-captures"
                  style={{ position: "fixed", left: -10000, top: 0, opacity: 0, pointerEvents: "none" }}
                >
                  {paginas.map((cats, i) => (
                    <div key={`hidden-${i}`} style={{ width: 1080, height: 1350 }}>
                      <Pagina cats={cats} />
                    </div>
                  ))}
                </div>
              )}

              {/* Navegação / páginas */}
              <div className="ig-pager">
                <button className="ig-btn" disabled={pagina <= 0} onClick={() => setPagina((p) => Math.max(0, p - 1))}>
                  ◀ IMAGEM ANTERIOR
                </button>
                <div className="ig-pager-info">
                  {paginas.length ? `${pagina + 1} / ${paginas.length}` : "—"}
                </div>
                <button
                  className="ig-btn"
                  disabled={pagina >= paginas.length - 1}
                  onClick={() => setPagina((p) => Math.min(paginas.length - 1, p + 1))}
                >
                  PRÓXIMA IMAGEM ▶
                </button>
              </div>

              {/* Downloads */}
              <div className="ig-dl">
                <button className="ig-btn blue" type="button" onClick={handleDownloadOne}>
                  DOWNLOAD DESTA IMAGEM (PNG)
                </button>
                {paginas.length > 1 && (
                  <button className="ig-btn blue" type="button" onClick={handleDownloadAll}>
                    DOWNLOAD DE TODAS AS IMAGENS (ZIP)
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
